<template>
  <div class="">
    <div class="poster"><img src="../../assets/aboutBanner.png" alt="" /></div>
    <div class="wrap">
      <div class="bg-content">
        <b-container>
          <div class="arrow"></div>
          <div class="intro">
            <div class="left">
              <div class="tit">公司简介</div>
            </div>
            <div class="right">
              <div class="text">
                广州市萌酷信息科技有限责任公司位于中国的南大门羊城广州，创立于2016年，萌酷科技立足数字化、信息技术方向全面发展。基于前期发展沉淀的经验，立足于服务品质，务实创新推动虚拟仿真。
              </div>
              <div class="link">
                <router-link to="/aboutUs">立即查看</router-link>
              </div>
            </div>
          </div>
        </b-container>
      </div>
      <b-container style="" class="business">
        <h2>我们业务</h2>
        <div class="content">
          <banner></banner>
        </div>
      </b-container>
      <div class="news">
        <b-container>
          <h2>新闻动态</h2>
        </b-container>
        <div class="div">
          <b-container class="news-content">
            <div class="newsHover" ref="newsHover"></div>
            <div
              class="content"
              v-for="(newsItem, newsIndex) in article"
              :key="newsIndex"
              @mouseover.stop="newEvent('over', $event, newsIndex)"
              @mouseleave.stop="newEvent('leave', $event, newsIndex)"
              @click.stop="toDetali(newsIndex)"
            >
              <div class="left" ref="left">
                <p>{{ newsItem.title }}</p>
                <span>{{ newsItem.date }}</span>
              </div>
              <div class="right">
                <img :src="newsItem.indexSrc" alt="" />
              </div>
            </div>
          </b-container>
        </div>
      </div>
      <b-container class="partners">
        <h2>合作伙伴</h2>
      </b-container>
      <div style="background: #fcfcfc; padding: 20px 0px">
        <b-container class="partners">
          <div class="content">
            <div
              class="imgs"
              v-for="(imgItem, imgIndex) in partnerData"
              :key="imgIndex"
            >
              <img :src="imgItem.src" alt="" />
            </div>
          </div>
        </b-container>
      </div>
      <b-container class="join">
        <h2>加入我们</h2>
        <router-link tag="div" to="/addUs" class="joinImg">
          <img src="../../assets/join.png" alt="" />
        </router-link>
      </b-container>
    </div>
  </div>
</template>
<script>
import banner from "@/components/banner.vue";
import artLists from "../../assets/json/news";
export default {
  data() {
    return {
      partnerData: [
        { src: require("../../assets/partner/p1.png") },
        { src: require("../../assets/partner/p2.png") },
        { src: require("../../assets/partner/p3.png") },
        { src: require("../../assets/partner/p4.png") },
        { src: require("../../assets/partner/p5.png") },
        { src: require("../../assets/partner/p6.png") },
        { src: require("../../assets/partner/p7.png") },
        { src: require("../../assets/partner/p8.png") },
        { src: require("../../assets/partner/p9.png") },
        { src: require("../../assets/partner/p10.png") },
        { src: require("../../assets/partner/p11.png") },
        { src: require("../../assets/partner/p12.png") },
        { src: require("../../assets/partner/p13.png") },
        { src: require("../../assets/partner/p14.png") },
        { src: require("../../assets/partner/p15.png") },
        { src: require("../../assets/partner/p16.png") },
      ],
      article: [
        {
          title:
            "2021国际虚拟现实创新大会·虚拟现实创新生态建设论坛在山东青岛召开",
          date: "2021-09-30",
          text: "<p>9月29日，2021国际虚拟现实创新大会在山东青岛召开。本次大会由山东省工业和信息化厅、青岛市人民政府主办，青岛市工业和信息化局、青岛市崂山区人民政府、山东省虚拟现实制造业创新中心、青岛星鲨虚拟现实技术研究院承办，青岛微电子创新中心有限公司、青岛虚拟现实研究院有限公司、星鲨信息技术（青岛）有限公司协办。山东省人民政府副省长凌文，工信部电子司副司长徐文立，山东省工信厅副厅长高方，青岛市人民政府副市长耿涛，崂山区委书记孙海生，崂山区委副书记、区长王锋等政府部门领导出席并发表致辞和讲话。中国工程院院士赵沁平，北京理工大学教授、教育部长江学者王涌天，法国拉瓦勒虚拟现实联盟秘书长劳伦克雷蒂安，歌尔股份有限公司高级副总裁刘耀诚等嘉宾就虚拟现实与5G及工业互联网的深度融合、虚拟现实产业发展新生态、增强现实头戴显示技术等热点议题展开精彩的讨论与交流。</p><p>9月29日下午，虚拟现实创新生态建设论坛顺利召开，来自虚拟现实领域高校、科研院所、企业的26位专家、学者和企业代表围绕“把握新机遇 共创新未来”的大会主题进行了深入探讨，80余位现场观众光临本论坛。</p><div class='imgs'><img src='http://n.sinaimg.cn/front20210930ac/515/w1270h845/20210930/e454-dc429592d127f514c107cf17e3641e1b.jpg' /></div><p>青岛虚拟现实研究院有限公司总经理严小天主持论坛开幕式并致辞，首先对出席论坛的各位领导、嘉宾、同行表示欢迎和感谢，并总结了2019年以来公司在山东省虚拟现实制造业创新中心建设、关键核心技术研发、产业链完善等方面取得的进展，创新中心作为山东省虚拟现实制造业创新发展的重要节点，将继续发挥行业引领作用，并以创建国家虚拟现实制造业创新中心为目标，积极协同产业资源和力量，认真落实建设规划，聚焦行业卡脖子关键技术，推动虚拟现实产业链上下游协同发展，加快构建良好产业生态。</p>",
          newsPic:
            "http://n.sinaimg.cn/front20210930ac/515/w1270h845/20210930/e454-dc429592d127f514c107cf17e3641e1b.jpg",
          indexSrc: require("../../assets/index01.png"),
        },
        {
          title: "NASA 将在国际空间站的维护中使用 HoloLens 头显",
          date: "2021-09-28",
          text: "<p>伴随着NASA在2024年以及2030年的月球与火星任务临近，增强现实技术也正被越来越多的运用到航天探索中。而作为航天与虚拟现实最发达的国家之一，美国在这方面的尝试也可谓先人一步。最近，NASA在其国际空间站正式部署了虚拟现实设备的使用，这其中就包括宇航员通过 HoloLens 头显来进行重要工作。</p><div class='imgs'><img src='http://n.sinaimg.cn/sina_vr/transform/7/w550h257/20210928/0a70-6c42a46a77e4eebaa01f11682377837f.jpg' /></div><p>目前，NASA所属的机组成员正在参与T2增强现实（T2AR）项目，该项目使用定制的AR软件，使团队能够维护和服务联合作业承重外阻力跑步机（COLBERT）。据了解，COLBERT是宇航员用于在无重力环境中的机载运动极致，它旨在帮助宇航员应对长时间的失重状态状态，并保持其肌肉和骨骼健康。</p><p>包括在该项目中的有NASA宇航员Megan McArthur，日本宇宙航空研究开发机构（JAXA）宇航员Soichi Noguchi，以及ESA（欧洲航天局）宇航员Thomas Pesquet。</p><div class='imgs'><img src='http://n.sinaimg.cn/sina_vr/transform/7/w550h257/20210928/3da8-e9add939d33925b5a98d3dd9b5a8bca9.jpg' /></div><p>约翰逊国际空间站科学家布莱恩·丹斯贝里在NASA官网的一份生命中表示：“AR工具有希望让我们预先包装好指导和专业知识，空间站也是测试AR系统和完善这些工具的完美平台，因此当未来的宇航员需要它们时，它们将准备就绪。在离家更近的地方，这些测试有助于现在成熟的软件和AR技术，因此在世界各地的偏远地区都可以获得专业知识和支持。”</p><p>事实上，HoloLens 头显首次进入太空是在2016年，当时的宇航员斯科特-凯利戴着沉浸式头显出现在国际空间站上，并同时漂浮在半空。那次是美国宇航局的Sidekick计划，这是一个非常早期的实验，旨在观察HoloLens在真正的太空环境中会如何表现。</p><div class='imgs'><img src='http://n.sinaimg.cn/sina_vr/transform/58/w550h308/20210928/818f-30dfe1840e11bf8c93a49a758ccb4887.png' /></div><p>同样值得注意的是，Sidekick 项目和这个新的 HoloLens 太空演示TRAR都使用HoloLens 1，与 HoloLens 2 相比，其功能相当有限。</p>",
          newsPic:
            "http://n.sinaimg.cn/sina_vr/transform/7/w550h257/20210928/0a70-6c42a46a77e4eebaa01f11682377837f.jpg",
          indexSrc: require("../../assets/index03.png"),
        },
        {
          title: "Unity 发布专业体育实时 3D 平台 Unity Metacast",
          date: "2021-10-08",
          text: "<p>开发并提供游戏制作引擎 Unity 的Unity Technologies 前些天发布了一款体育实时 3D 分发和观看平台 Unity Metacast。 与综合格斗组织 UFC（Ultimate Fighting Championship） 合作，用 VR 技术拍摄了参赛选手。观众可以观看到擂台内和选手比赛的所有角度。</p><div class='imgs'><img src='http://n.sinaimg.cn/sina_vr/transform/55/w550h305/20211008/47b3-e73fa29b06eb7372f4fb781e8d351a1d.png' /></div><p>Unity Metacast 是一个实时3D 体育平台，用于创建交互式内容并直接提供给观众。 采用了VR 全景技术，可以从所有角度实时收看选手和舞台。 Unity 宣称“观众就像自己在舞台中对决一样，可以看到汗水、击球、起飞、降落”。</p><p>Unity 体育与直播娱乐总经理彼得·摩尔这样评价道： “体育体验不再是单纯给予 2D 内容，未来的发展一定是可以如同身临其境一样让人可以得到更加真实的体验。”</p><p>Unity 和 UFC 合作共同探索 Unity Metacast 为体育和现场娱乐领域带来的各种可能性。 两家公司表示，Unity Metacast“将重新定义体育的运营和管理方法，以及球迷和球员参与体育内容的方式”。</p>",
          newsPic:
            "http://n.sinaimg.cn/sina_vr/transform/55/w550h305/20211008/47b3-e73fa29b06eb7372f4fb781e8d351a1d.png",
          indexSrc: require("../../assets/index02.png"),
        },
      ],
    };
  },
  created() {
    this.article = this.article.splice(0, 3);
  },
  methods: {
    newEvent(status, e, index) {
      let flag = true;
      if (flag) {
        this.$refs.newsHover.style.display = "block";
        let top = this.$refs.left[index].offsetTop;
        // console.log(top);
        // console.log(e.path);
        this.$refs.newsHover.style.top = top + "px";
        if (status == "over") {
          this.$refs.left[index].children[0].style.color = "#4899EF";
          this.$refs.left[index].children[1].style.color = "#4899EF";
        } else {
          this.$refs.left[index].children[0].style.color = "#333";
          this.$refs.newsHover.style.display = "none";
          this.$refs.left[index].children[1].style.color = "#999";
        }
        flag = false;
      }
    },
    toDetali(index) {
      this.$router.push(`/new/detail?id=${index}`);
    },
  },
  components: {
    banner,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
}
.poster {
  margin-top: 80px;
  width: 100%;
  img {
    width: 100%;
  }
}
.wrap {
  box-sizing: border-box;
  .bg-content {
    height: 868px;
    background-position: -150px 115px;
    background-image: url(../../assets/introbg.png);
    background-repeat: no-repeat;
    background-size: 100%;
    .arrow {
      margin: auto;
      margin-top: 58px;
      margin-bottom: 12px;
      width: 65px;
      height: 30px;
      background-image: url(../../assets/arrow.png);
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .intro {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 164px 48px 144px 0px;
      background: #fbfbfb;
      box-shadow: 10px 20px 60px rgba(49, 199, 223, 0.15);
      .left {
        width: 25%;
        height: 270px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        border-right: 1px solid #e8e8e8;
        .tit {
          width: 160px;
          color: #333;
          font-size: 40px;
        }
      }
      .right {
        padding-top: 90px;
        width: 75%;
        padding-left: 45px;
        padding-right: 20px;
        text-align: justify;
        color: #999;
        line-height: 30px;
        font-weight: 300;
        .link {
          padding-top: 100px;
          text-align: right;
          a {
            color: #3c8cff;
            font-size: 18px;
          }
        }
      }
    }
  }
  .news,
  .partners,
  .business,
  .join {
    h2 {
      text-indent: 90px;
      position: relative;
      margin: 172px 0 74px;
      font-size: 40px;
      font-weight: 500;
      color: #333;
      &::after {
        position: absolute;
        left: 4.8125rem;
        top: -2.75rem;
        font-size: 64px;
        font-family: PangMenZhengDao;
        color: #5cb0f9;
        opacity: 0.06;
      }
    }
  }
  .business {
    h2 {
      &::after {
        content: "Our business";
        text-transform: Uppercase;
      }
    }
    .content {
      box-shadow: -3px 2px 8px rgb(83 199 251 / 26%);
    }
  }
  .news {
    h2 {
      &::after {
        content: "news";
        text-transform: Uppercase;
      }
    }
    .div {
      cursor: pointer;
      background: #fcfcfc;
      padding: 20px 10px;
      .news-content {
        position: relative;
        background: #ffffff;
        border: 1px solid #eeeeee;
        padding: 20px;
        .newsHover {
          width: 0.5rem;
          height: 5.5rem;
          background: #3fd3fe;
          position: absolute;
          top: 8.4rem;
          left: 0;
          transition: all 0.4s;
          display: none;
        }
        .content {
          margin-bottom: 45px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          .hoverLine {
            width: 0.5rem;
            height: 5.1rem;
            background: #3fd3fe;
            position: absolute;
            top: 2rem;
            transition: all 0.4s;
            display: none;
          }
          .left {
            padding-left: 80px;
            width: 47.5%;
            P {
              font-size: 20px;
              color: #333333;
              margin-bottom: 20px;
              text-overflow: ellipsis;
              display: -webkit-box;
              overflow: hidden;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            span {
              font-size: 14px;
              color: #999;
            }
          }
          .right {
            width: 34%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .partners {
    width: 100%;
    h2 {
      &::after {
        content: "partners";
        text-transform: Uppercase;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .imgs {
        padding: 25px;
        width: 25%;
        img {
          width: 100%;
        }
      }
    }
  }

  .join {
    cursor: pointer;
    margin-bottom: 332px;
    width: 100%;
    h2 {
      &::after {
        content: "Join us";
        text-transform: Uppercase;
      }
    }
    .joinImg {
      // background-color: #fcfcfc;
      box-shadow: 0px 3px 50px rgba(10, 116, 255, 0.1);
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .poster {
    margin-top: 60px;
  }
  .wrap {
    // padding: 0 20px;
    .bg-content {
      height: 190px;
      background-position: -65px 85px;
      .arrow {
        margin-top: 30px;
        margin-bottom: 24px;
        width: 21px;
        height: 20px;
        background-size: 100%;
      }
      .intro {
        padding: 0;
        height: 150px;
        .left {
          height: 72px;
          .tit {
            font-size: 16px;
          }
        }
        .right {
          padding-top: 15px;
          padding-left: 16px;
          .text {
            // max-height: 56px;
            padding-top: 25px;
            overflow: hidden;
            line-height: 18px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            color: #666666;
            line-height: 18px;
            font-size: 12px;
          }
          .link {
            padding-top: 10px;
            a {
              color: #3c8cff;
              font-size: 10px;
              font-weight: 400;
            }
            i {
              transform: scale(0.5);
            }
          }
        }
      }
    }
    .business,
    .join {
      padding: 0 20px;
    }
    .news,
    .partners,
    .business,
    .join {
      h2 {
        margin: 62px 0 8px -82px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
        // text-indent: 25px;
        &::after {
          left: 1.8125rem;
          top: -0.75rem;
          font-size: 18px;
          font-weight: bolder;
        }
      }
      .content {
        .left {
          width: 75%;
          p {
            font-size: 14px;
            margin: 0;
            height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          span {
            font-size: 12px;
          }
        }
        .right {
          width: 25%;
        }
      }
    }
    .partners {
      width: 100%;
      h2 {
        padding: 0 20px;
      }
      .content {
        padding: 0 20px;
        justify-content: space-between;
        .imgs {
          padding: 0;
          width: 23%;
          img {
            width: 100%;
          }
        }
      }
    }
    .news {
      h2 {
        padding: 0 20px;
      }
      .div {
        padding: 0;
        background-color: #fff;
        .news-content {
          padding: 20px 20px 0;
          .newsHover {
            width: 0.5rem;
            height: 5.5rem;
            background: #3fd3fe;
            position: absolute;
            top: 8.4rem;
            left: 0;
            transition: all 0.4s;
            display: none;
          }
          .content {
            // .hoverLine {
            //   width: 0.5rem;
            //   height: 5.1rem;
            //   background: #3fd3fe;
            //   position: absolute;
            //   top: 2rem;
            //   transition: all 0.4s;
            //   display: none;
            // }
            margin-bottom: 15px;
            .left {
              padding-left: 0px;
              width: 70%;
              P {
                margin-bottom: 0px;
                font-size: 12px;
                color: #333333;
              }
              span {
                font-size: 10px;
                color: #999;
              }
            }
            .right {
              width: 24%;
              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .join {
      margin-bottom: 60px;
    }
  }
}
</style>  